import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1233c6a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "border bg-gray-light rounded-md" }
const _hoisted_2 = { class: "py-4 px-4 relative" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "flex items-center space-x-4 hoverable p-2" }
const _hoisted_5 = {
  key: 0,
  class: "text-right summary-price"
}
const _hoisted_6 = { class: "detail--large" }

import { computed, onMounted, ref, watch } from 'vue';
import { Icon } from '@iconify/vue';
import { roundNumber } from '@/utils/numbers';
import { CHAIN_TITLE } from '@/constants';
import { getBNBtoUSDT } from '@/apis/prices';
import useMoralis from '@/composables/useMoralis';
import { useUserStore } from '@/store/user';
import OptionItemPayment from '../OptionItemPayment.vue';
import { Currency } from '@/types/Donate';
import { Price } from '@/types/Price';
import { numberWithCommas } from '@/composables/format';

export interface DonateSummaryPayment extends Omit<Price, 'symbol'> {
  tokenAddress?: string;
  abi?: object;
  symbol?: Currency;
}

interface Props {
  payment?: number;
  amount?: number;
  payments?: DonateSummaryPayment[];
}

export default /*#__PURE__*/_defineComponent({
  props: {
    payment: { default: 0 },
    amount: { default: 1 },
    payments: { default: () => [] }
  },
  emits: ['update:payment'],
  setup(__props: any) {

const props = __props as { payment: number, amount: number, payments: DonateSummaryPayment[] }




const moralis = useMoralis();
const user = useUserStore();
const active = computed<DonateSummaryPayment | undefined>(
  () => props.payments[props.payment]
);
const totalPrice = computed(() =>
  active.value
    ? roundNumber(props.amount * (active.value.pricePerContract ?? 0))
    : 0
);

const usdtRate = ref<number>(0);
const getRate = async () => {
  usdtRate.value = await getBNBtoUSDT();
};

const formatBalance = (balance: string) => {
  return moralis.currect.Units.FromWei(balance, 18).toString();
};
const balance = ref<string>('0');
const getBalance = async ({
  account,
  payment,
}: {
  account?: string;
  payment: DonateSummaryPayment;
}) => {
  if (!account) return;
  const { tokenAddress, abi, name } = payment;
  if (!abi) return;
  if (name === 'BNB') {
    moralis.currect.Web3API.account
      .getNativeBalance({
        chain: CHAIN_TITLE,
        address: account,
      })
      .then((res) => {
        balance.value = formatBalance(res.balance);
      });
  } else if (tokenAddress) {
    moralis.currect.Web3.executeFunction({
      abi: abi,
      contractAddress: tokenAddress,
      functionName: 'balanceOf',
      params: { account, '': account },
    }).then((value) => {
      balance.value = formatBalance(value);
    });
  }
};
watch(
  [active, () => user.ethAddress],
  (values) => {
    const [payment, account] = values as [DonateSummaryPayment?, string?];
    payment && account && getBalance({ account, payment });
  },
  { immediate: true }
);

onMounted(() => getRate());

return (_ctx: any,_cache: any) => {
  const _component_VDropdown = _resolveComponent("VDropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_VDropdown, {
          "popper-hide-triggers": ['click'],
          placement: "bottom-start"
        }, {
          popper: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.payments, (option, idx) => {
              return (_openBlock(), _createBlock(OptionItemPayment, {
                key: option.name,
                name: option.name,
                description: option.description,
                image: option.imageURL,
                class: "p-4",
                spaced: "space-x-4 hoverable",
                style: {"width":"295px"},
                onClick: ($event: any) => (_ctx.$emit('update:payment', idx))
              }, null, 8, ["name", "description", "image", "onClick"]))
            }), 128))
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              (_unref(active))
                ? (_openBlock(), _createBlock(OptionItemPayment, {
                    key: 0,
                    name: _unref(active).name,
                    description: _unref(active).description,
                    image: _unref(active).imageURL,
                    sized: "large"
                  }, null, 8, ["name", "description", "image"]))
                : _createCommentVNode("", true),
              _createVNode(_unref(Icon), { icon: "ep:arrow-down-bold" })
            ])
          ]),
          _: 1
        }),
        (_unref(active))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(numberWithCommas)(_unref(totalPrice))) + " " + _toDisplayString(_unref(active).name), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})